export const LOCALE_EN = 'en';
export const LOCALE_FR = 'fr';

export const LOCALES = [
  LOCALE_EN,
  LOCALE_FR,
] as const;

export type Locale = (typeof LOCALES)[number];

export const LOCALE_DEFAULT = LOCALE_EN satisfies Locale;
